import { Component, Input, OnInit } from "@angular/core";
import { SharedModule } from "../../shared.module";

@Component({
  selector: "vl-title",
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./title.component.html",
  styleUrls: ["./title.component.scss"],
})
export class TitleComponent implements OnInit {
  @Input() prefix?: string | number;
  @Input() variable?: string | number;
  @Input() suffix?: string | number;
  @Input() white?: boolean = false;
  @Input() big?: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
